'use client';

import { useTranslations } from 'next-intl';
import type { RingBuyStepId } from 'components/ring-air/utils/buySteps';

/** Bottom-bar CTA copy for the step the shopper has to answer next. */
export function useNextStepLabel(stepId: RingBuyStepId | null): string {
  const t = useTranslations('ring');
  switch (stepId) {
    case 'color-picker':
      return t('ring.productSelection.nextStep.colorPicker');
    case 'size-select':
      return t('ring.productSelection.nextStep.sizeSelect');
    case 'charger-select':
      return t('ring.productSelection.nextStep.chargerSelect');
    case 'trade-in':
      return t('ring.productSelection.nextStep.tradeIn');
    case 'engraving':
      return t('ring.productSelection.nextStep.engraving');
    case 'clue-addon':
      return t('ring.productSelection.nextStep.clueAddon');
    case 'max':
      return t('ring.productSelection.nextStep.max');
    case 'bling-stacking':
      return t('ring.productSelection.nextStep.blingStacking');
    default:
      return t('ring.CONTINUE');
  }
}
